export default (form) => {
	[...form.querySelectorAll('label:not([for])')].forEach(label => {
		const named = label.parentNode.querySelector('[name]');
		named.setAttribute('id', named.getAttribute('id') || uniqueId(named.getAttribute('name')));
		label.setAttribute('for', named.getAttribute('id'));
	});
};

function uniqueId(id,current){
	current = current || 0;
	var idCheck = id + (current === 0 ? '' : '-'+current);
	return document.getElementById(idCheck) ? uniqueId(id,current+1) : idCheck;
}